import { FiCheck, FiClock } from "react-icons/fi";

// Read-only status display — NO upload capability here.
// Actual upload happens once, in bulk, from SelectedQuotationsListView.
const SampleBankTransferStatusCard = ({ bankTransferDocument }) => {
  const status = bankTransferDocument?.status || null;

  if (status === "VERIFIED") {
    return (
      <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-emerald-600 text-lg">✅</span>
          <p className="text-sm font-bold text-emerald-700">
            Bank Transfer Verified
          </p>
        </div>
        <p className="text-xs text-emerald-600 leading-relaxed">
          Your payment proof has been verified. This sample is being processed.
        </p>
      </div>
    );
  }

  if (status === "UPLOADED") {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-blue-600 text-lg">📋</span>
          <p className="text-sm font-bold text-blue-700">
            Bank Transfer Proof Under Review
          </p>
        </div>
        <p className="text-xs text-blue-600 leading-relaxed">
          Your payment proof has been submitted and is being verified by our team.
        </p>
      </div>
    );
  }

  if (status === "REJECTED") {
    return (
      <div className="bg-red-50 border border-red-200 rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-red-600 text-lg">❌</span>
          <p className="text-sm font-bold text-red-700">
            Bank Transfer Proof Rejected
          </p>
        </div>
        <p className="text-xs text-red-600 leading-relaxed">
          {bankTransferDocument?.adminRemarks ||
            "Your proof was rejected. Please re-upload it from the sample quotations list."}
        </p>
      </div>
    );
  }

  // No document yet — waiting for buyer to upload from the list view
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-1">
        <FiClock className="text-amber-600" size={16} />
        <p className="text-sm font-bold text-amber-700">
          Payment Proof Pending
        </p>
      </div>
      <p className="text-xs text-amber-600 leading-relaxed">
        Please upload your bank transfer proof from the sample quotations list view to complete this order.
      </p>
    </div>
  );
};

export default SampleBankTransferStatusCard;